module.exports = __webpack_public_path__ + "img/integrations-pair-2.60b94ac6.png";